import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { KbMyTicketService } from 'src/app/services/feature/mytickets/kb-my-tickets.service';
import { TicketEditComponent } from './ticket-edit/ticket-edit.component';
import { GlobalMessageService, GlobalMessageType, OccEndpointsService } from '@spartacus/core';

@Component({
  selector: 'app-update-my-tickets',
  templateUrl: './update-my-tickets.component.html',
  styleUrls: ['./update-my-tickets.component.scss'],
  standalone: false
})
export class UpdateMyTicketsComponent {
  today: Date;
  canLoad: boolean = false;
  isMobile: boolean = false;
  Data: any;
  sub = new Subscription();
  baseUrl: string = '';
  code: string = '';
  id: string = '';
  status = [
    {
      code: "New",
      name: "OPEN"
    },
    {
      code: "Open",
      name: "INPROGRESS"
    },
    {
      code: "Customeraction",
      name: "CUSTOMERACTION"
    },
    {
      code: "Completed",
      name: "COMPLETED"
    },
    {
      code: "Closed",
      name: "CLOSED"
    }
  ];
  constructor(private breakpointObserver: BreakpointObserver,
    private service: KbMyTicketService,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private endPointService: OccEndpointsService,
    private matDialog: MatDialog,
    private globalmessage: GlobalMessageService) {
    this.today = new Date();
    this.sub.add(
      this.breakpointObserver
        .observe([Breakpoints.XSmall, Breakpoints.Small])
        .subscribe((result) => {
          this.isMobile = result.matches;
        }));
    this.baseUrl = this.endPointService.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
  }

  ngOnInit() {
    this.sub.add(this.activatedRoute.queryParamMap.subscribe((params) => {
      this.id = params.get('id');
      this.code = params.get('code');
      this.getApi();
    }));
  }

  getApi() {
    this.sub.add(this.service.ticketUpdateGetApi(this.id, this.code).subscribe((apiResponse: any) => {
      this.Data = apiResponse;
      this.canLoad = true;
      this.cdr.detectChanges();
    }));
  }
  openPopup() {
    const ref = this.matDialog.open(TicketEditComponent);
    this.sub.add(ref.afterClosed().subscribe(
      () => {
        if (this.service.isFromUpdateTicketPage) {
          this.globalmessage.add(this.service.isFromUpdateTicketPageKey, GlobalMessageType.MSG_TYPE_INFO);
          this.getApi();
        }
      }
    ))
  }
  ngOnDestroy() {
    this.sub.unsubscribe();
  }

}
